import { NgModule } from '@angular/core';
import { PLegendComponent } from './p-legend.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [CommonModule, TranslateModule],
    exports: [PLegendComponent, PLegendComponent],
    declarations: [PLegendComponent]
})
export class PLegendModule {}
